import classnames from 'classnames/bind';
import Typography from 'components/Typography';
import React from 'react';
import { useSelector } from 'react-redux';
import useCopyToClipboard from 'hooks/useCopyToClipboard';
import { ROOT_URL } from 'config';

import styles from './ShareClassCode.module.scss';

const cx = classnames.bind(styles);

const ShareClassCode = ({ componentRef }) => {
  const {
    operatingClassroom: { name, code },
  } = useSelector(({ classroom }) => classroom);

  const joinUrl = `${ROOT_URL}/join/${code}`;
  const [copied, copy] = useCopyToClipboard(joinUrl);

  return (
    <>
      <Typography type="h4">Share Classroom Code</Typography>

      <Typography className={cx('description', 'mgt-15', 'mgb-25')}>
        Share this code or link with your students. They will sign in with their NYC Schools account
        and join your classroom automatically.
      </Typography>

      <div className={styles.codeContainer} ref={componentRef}>
        <div className={styles.infoRow}>
          <Typography className={styles.label}>Classroom:</Typography>
          <Typography>{name}</Typography>
        </div>

        <div className={styles.infoRow}>
          <Typography className={styles.label}>Classroom Code:</Typography>
          <Typography className={styles.codeValue}>{code}</Typography>
        </div>

        <div className={styles.linkSection}>
          <Typography className={styles.label}>Join Link:</Typography>
          <div className={styles.linkRow}>
            <Typography className={styles.linkValue}>{joinUrl}</Typography>
            <button type="button" className={styles.copyButton} onClick={copy}>
              {copied ? 'Copied!' : 'Copy'}
            </button>
          </div>
        </div>

        <div className={styles.instructions}>
          <Typography className={styles.label}>Instructions for Students:</Typography>
          <ol className={styles.stepsList}>
            <li>Go to the link above (or enter the code on the Join page)</li>
            <li>Click "Sign in with NYC Schools"</li>
            <li>Log in with your school account</li>
            <li>You will be automatically added to the classroom</li>
          </ol>
        </div>
      </div>
    </>
  );
};

export default ShareClassCode;
